(() => {
 const tmCopy = {"Le gestionnaire de consentement est momentanément indisponible. Aucun nouveau choix n’a été enregistré.": ["Die Einwilligungsverwaltung ist vorübergehend nicht verfügbar. Es wurde keine neue Auswahl gespeichert.", "La gestione del consenso è momentaneamente non disponibile. Nessuna nuova scelta è stata salvata.", "The consent manager is temporarily unavailable. No new choice has been saved."], "Votre choix n’a pas pu être confirmé. Veuillez réessayer.": ["Ihre Auswahl konnte nicht bestätigt werden. Bitte versuchen Sie es erneut.", "Non è stato possibile confermare la Sua scelta. Riprovi.", "Your choice could not be confirmed. Please try again."]};
 function tmSay(source) {
  const index = ["de", "it", "en"].indexOf(document.documentElement.lang.split("-")[0]);
  return tmCopy[source]?.[index] ?? source;
 }

  const PURPOSES = ['preferences', 'analytics', 'marketing'];
  const NATIVE_BANNER_SELECTOR = '#shopify-pc__banner';
  const NATIVE_BANNER_WAIT_MS = 3000;
  const LOAD_ERROR_MESSAGE =
    tmSay("Le gestionnaire de consentement est momentanément indisponible. Aucun nouveau choix n’a été enregistré.");
  const SAVE_ERROR_MESSAGE =
    tmSay("Votre choix n’a pas pu être confirmé. Veuillez réessayer.");

  function initCookieConsent(root) {
    if (root.dataset.cookieConsentReady === 'true') return;
    root.dataset.cookieConsentReady = 'true';

    const banner = root.querySelector('[data-cookie-banner]');
    const dialog = root.querySelector('[data-cookie-dialog]');
    const reopenButton = root.querySelector('[data-cookie-reopen]');
    // Keep settings accessible without a floating control over the storefront.
    const footer = Array.from(document.querySelectorAll('footer')).find((element) => !element.closest('blockquote'));
    if (footer && reopenButton) {
      const footerLink = document.createElement('div');
      footerLink.className = 'tm-cookie__footer-link';
      footerLink.append(reopenButton);
      footer.append(footerLink);
    }
    const statusNodes = root.querySelectorAll('[data-cookie-status]');
    const actionButtons = root.querySelectorAll('[data-cookie-action]');
    const checkboxes = Object.fromEntries(
      PURPOSES.map((purpose) => [
        purpose,
        root.querySelector(`[data-cookie-purpose="${purpose}"]`),
      ])
    );

    let privacyApi = null;
    let apiReady = false;
    let submitting = false;
    let lastFocusedElement = null;
    let initialBannerTimer = null;

    function setStatus(message) {
      statusNodes.forEach((node) => {
        node.textContent = message;
      });
    }

    function setBusy(isBusy) {
      submitting = isBusy;
      root.toggleAttribute('aria-busy', isBusy);
      actionButtons.forEach((button) => {
        button.disabled = isBusy || !apiReady;
      });
    }

    function readConsent() {
      if (!privacyApi || typeof privacyApi.currentVisitorConsent !== 'function') return null;

      try {
        return privacyApi.currentVisitorConsent();
      } catch (error) {
        return null;
      }
    }

    function syncCheckboxes(consent) {
      if (!consent) return;

      PURPOSES.forEach((purpose) => {
        if (checkboxes[purpose]) {
          checkboxes[purpose].checked = consent[purpose] === 'yes';
        }
      });
    }

    function hasTrackingDecision(consent) {
      // Legacy Shopify choices can omit preferences. Both tracking purposes
      // must have an explicit answer; accepting and refusing are equal choices.
      return ['analytics', 'marketing'].every(
        (purpose) => consent && ['yes', 'no'].includes(consent[purpose])
      );
    }

    function shouldShowInitialBanner(consent) {
      // shouldShowBanner can describe the visitor's region even after a choice.
      // The saved choice always takes priority over that regional signal.
      if (!consent || hasTrackingDecision(consent)) return false;
      let shopifyRequestsBanner = false;

      if (privacyApi && typeof privacyApi.shouldShowBanner === 'function') {
        try {
          shopifyRequestsBanner = privacyApi.shouldShowBanner() === true;
        } catch (error) {
          shopifyRequestsBanner = false;
        }
      }

      return shopifyRequestsBanner;
    }

    function getNativeBannerState() {
      const nativeBanner = document.querySelector(NATIVE_BANNER_SELECTOR);
      if (!nativeBanner) return {element: null, present: false, visible: false};

      const styles = window.getComputedStyle(nativeBanner);
      const visible =
        !nativeBanner.hidden &&
        nativeBanner.getAttribute('aria-hidden') !== 'true' &&
        styles.display !== 'none' &&
        styles.visibility !== 'hidden' &&
        nativeBanner.getClientRects().length > 0;

      return {element: nativeBanner, present: true, visible};
    }

    function clearInitialBannerTimer() {
      if (!initialBannerTimer) return;
      window.clearTimeout(initialBannerTimer);
      initialBannerTimer = null;
    }

    function suppressInitialBannerForNative() {
      const nativeBannerState = getNativeBannerState();
      if (!nativeBannerState.visible) return false;

      clearInitialBannerTimer();
      if (!banner.hidden) banner.hidden = true;
      return true;
    }

    function monitorNativeBanner() {
      let observedNativeBanner = null;
      const nativeVisibilityObserver = new MutationObserver(() => {
        scheduleInitialBanner();
      });

      function observeNativeBanner() {
        const nativeBannerState = getNativeBannerState();
        scheduleInitialBanner();

        if (nativeBannerState.element === observedNativeBanner) return;
        nativeVisibilityObserver.disconnect();
        observedNativeBanner = nativeBannerState.element;
        if (!observedNativeBanner) return;
        nativeVisibilityObserver.observe(observedNativeBanner, {
          attributes: true,
          attributeFilter: ['aria-hidden', 'class', 'hidden', 'style'],
        });
      }

      const nativeInjectionObserver = new MutationObserver(observeNativeBanner);
      nativeInjectionObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });

      observeNativeBanner();
    }

    function scheduleInitialBanner() {
      if (!apiReady) return;
      if (!shouldShowInitialBanner(readConsent())) {
        clearInitialBannerTimer();
        if (!banner.hidden) banner.hidden = true;
        return;
      }
      if (suppressInitialBannerForNative() || initialBannerTimer || !banner.hidden) return;

      initialBannerTimer = window.setTimeout(() => {
        initialBannerTimer = null;

        // A native dialog or another tab can save a choice during the delay.
        if (!shouldShowInitialBanner(readConsent()) || suppressInitialBannerForNative()) return;
        banner.hidden = false;
      }, NATIVE_BANNER_WAIT_MS);
    }

    function closeDialog() {
      if (dialog.open && typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    function openDialog(trigger) {
      lastFocusedElement = trigger || document.activeElement;
      setStatus('');

      const consent = readConsent();
      if (consent) syncCheckboxes(consent);

      if (!apiReady) {
        banner.hidden = false;
        setStatus(LOAD_ERROR_MESSAGE);
        return;
      }

      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function finishDialogClose() {
      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    function requestedConsentMatches(requested, saved) {
      if (!saved) return false;

      return PURPOSES.every((purpose) => {
        const expected = requested[purpose] ? 'yes' : 'no';
        return saved[purpose] === expected;
      });
    }

    function persistConsent(requested) {
      if (!apiReady || !privacyApi || typeof privacyApi.setTrackingConsent !== 'function') {
        setStatus(LOAD_ERROR_MESSAGE);
        return;
      }

      if (submitting) return;
      setStatus('');
      setBusy(true);
      let saveTimeout;

      try {
        saveTimeout = window.setTimeout(() => {
          setBusy(false);
          setStatus(SAVE_ERROR_MESSAGE);
        }, 8000);

        privacyApi.setTrackingConsent(requested, (result) => {
          window.clearTimeout(saveTimeout);
          const callbackHasError = Boolean(result && result.error);
          const savedConsent = callbackHasError ? null : readConsent();

          if (callbackHasError || !requestedConsentMatches(requested, savedConsent)) {
            setBusy(false);
            setStatus(SAVE_ERROR_MESSAGE);
            return;
          }

          syncCheckboxes(savedConsent);
          setBusy(false);
          clearInitialBannerTimer();
          banner.hidden = true;
          closeDialog();
          setStatus('');
        });
      } catch (error) {
        window.clearTimeout(saveTimeout);
        setBusy(false);
        setStatus(SAVE_ERROR_MESSAGE);
      }
    }

    function bindExternalReopenButton() {
      const externalButtonId = root.dataset.reopenButtonId;
      if (!externalButtonId) return;

      const externalButton = document.getElementById(externalButtonId);
      if (!externalButton || externalButton === reopenButton) return;

      externalButton.setAttribute('aria-haspopup', 'dialog');
      externalButton.addEventListener('click', (event) => {
        event.preventDefault();
        openDialog(externalButton);
      });
    }

    root.addEventListener('click', (event) => {
      const actionButton = event.target.closest('[data-cookie-action]');
      if (!actionButton || !root.contains(actionButton)) return;

      const action = actionButton.dataset.cookieAction;

      if (action === 'accept') {
        persistConsent({preferences: true, analytics: true, marketing: true});
      } else if (action === 'reject') {
        persistConsent({preferences: false, analytics: false, marketing: false});
      } else if (action === 'customize') {
        openDialog(actionButton);
      } else if (action === 'save') {
        persistConsent({
          preferences: Boolean(checkboxes.preferences?.checked),
          analytics: Boolean(checkboxes.analytics?.checked),
          marketing: Boolean(checkboxes.marketing?.checked),
        });
      } else if (action === 'cancel') {
        closeDialog();
      }
    });

    reopenButton.addEventListener('click', () => openDialog(reopenButton));
    dialog.addEventListener('close', finishDialogClose);
    document.addEventListener('visitorConsentCollected', () => {
      const consent = readConsent();
      if (!consent) return;

      syncCheckboxes(consent);
      scheduleInitialBanner();
    });
    window.addEventListener('pageshow', () => scheduleInitialBanner());

    bindExternalReopenButton();
    monitorNativeBanner();

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      reopenButton.hidden = false;
      setBusy(false);
      apiReady = false;
      return;
    }

    window.Shopify.loadFeatures(
      [{name: 'consent-tracking-api', version: '0.1'}],
      (error) => {
        if (error || !window.Shopify.customerPrivacy) {
          reopenButton.hidden = false;
          apiReady = false;
          setBusy(false);
          return;
        }

        privacyApi = window.Shopify.customerPrivacy;
        apiReady = true;
        setBusy(false);

        const consent = readConsent();
        if (!consent) {
          apiReady = false;
          setBusy(false);
          reopenButton.hidden = false;
          return;
        }

        syncCheckboxes(consent);
        reopenButton.hidden = false;
        scheduleInitialBanner();
      }
    );
  }

  function initAllCookieConsentComponents() {
    document.querySelectorAll('[data-tm-cookie-consent]').forEach(initCookieConsent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCookieConsentComponents, {once: true});
  } else {
    initAllCookieConsentComponents();
  }
})();
